import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { DynamicRouteService } from '../../pages/page-builder/services/dynamic-route.service';

/**
 * Guard to ensure dynamic routes are initialized and validate route existence
 */
export const DynamicRouteGuard: CanMatchFn = async (
  route: Route,
  segments: UrlSegment[],
): Promise<boolean> => {
  try {
    const dynamicRouteService = inject(DynamicRouteService);

    // Ensure routes are initialized
    await dynamicRouteService.ensureInitialized();

    // For dynamic routes, validate that the route actually exists
    // Skip validation for manual/static routes or if no segments
    if (segments.length > 0 && route.canMatch?.includes(DynamicRouteGuard)) {
      const fullPath = segments.map((s) => s.path).join('/');
      return dynamicRouteService.isRouteExists(fullPath);
    }

    return true;
  } catch (error) {
    console.error('Error in DynamicRouteGuard:', error);
    return false; // Fail safely
  }
};
